import ComissionedPayrollRegistration from './ComissionedPayrollRegistration';

export default ComissionedPayrollRegistration;